import { Injectable } from '@angular/core';
import * as joint from '@clientio/rappid';

import { BaseGraph } from './graph/BaseGraph';
import { EmptyGraph } from './graph/EmptyGraph';
import { JointJSGraph } from './graph/JointJSGraph';

/**
 * This FlowchartModelService is responsible of serving the graph.
 * Used per FlowchartComponent (not on root).
 * The graph can either be the real graph after init or the empty graph before init
 * @param paper
 */
@Injectable()
export class FlowchartModelService {
  flowchartGraph: BaseGraph;

  setJointJsGraph(graph: joint.dia.Graph) {
    this.flowchartGraph = new JointJSGraph(graph);
  }

  /**
   * Returns a Graph based on BaseGraph according to current state of the service
   * The Proxy Object decides to return the correct BaseGraph.
   */
  getGraph(): BaseGraph {
    const handler: ProxyHandler<any> = {
      get: (target: any, prop: string | symbol, receiver: any) => {
        const user = this.flowchartGraph ? this.flowchartGraph : new EmptyGraph();
        return Reflect.get(user, prop, receiver);
      },
    };

    return new Proxy({}, handler) as BaseGraph;
  }
}
